import { RouteConfig } from "vue-router";

const routes: Array<RouteConfig> = [
    // TransferZones
    {
        path: "/transfers/maintenances/zones",
        name: "GetAllTransferZones",
        meta: { title: "Zonas de traslado" },
        component: () => import(/* webpackChunkName: "transferzone" */ "../views/TransferZones/GetAllTransferZonesView.vue"),
    },
    {
        path: "/transfers/maintenances/zones/new",
        name: "NewTransferZone",
        meta: { title: "Zonas de traslado" },
        component: () => import(/* webpackChunkName: "transferzone" */ "../views/TransferZones/GetTransferZoneView.vue"),
    },
    {
        path: "/transfers/maintenances/zones/:id",
        name: "ViewTransferZone",
        meta: { title: "Zonas de traslado" },
        component: () => import(/* webpackChunkName: "transferzone" */ "../views/TransferZones/GetTransferZoneView.vue"),
    },
    {
        path: "/transfers/maintenances/zones/:id/edit",
        name: "EditTransferZone",
        meta: { title: "Zonas de traslado" },
        component: () => import(/* webpackChunkName: "transferzone" */ "../views/TransferZones/GetTransferZoneView.vue"),
    },

    // TransferBookings
    {
        path: "/transfers/bookings/all",
        name: "GetAllTransferBookings",
        meta: { title: "Reservas" },
        component: () => import(/* webpackChunkName: "transferbooking" */ "../views/TransferBookings/GetAllTransferBookingsView.vue"),
    },
    {
        path: "/transfers/bookings/new",
        name: "NewTransferBooking",
        meta: { title: "Nueva reserva" },
        component: () => import(/* webpackChunkName: "transferbooking" */ "../views/TransferBookings/NewTransferBookingView.vue"),
    },
    {
        path: "/transfers/bookings/booking-center/:id",
        name: "ViewTransferBooking",
        meta: { title: "Reservas" },
        component: () => import(/* webpackChunkName: "transferbooking" */ "../views/TransferBookings/GetTransferBookingView.vue"),
    },
    // TransferProducts
    {
        path: "/transfers/maintenances/products",
        name: "GetAllTransferProducts",
        meta: { title: "Productos" },
        component: () => import(/* webpackChunkName: "transferproduct" */ "../views/TransferProducts/GetAllTransferProductsView.vue"),
    },
    {
        path: "/transfers/maintenances/products/new",
        name: "NewTransferProduct",
        meta: { title: "Productos" },
        component: () => import(/* webpackChunkName: "transferproduct" */ "../views/TransferProducts/GetTransferProductView.vue"),
    },
    {
        path: "/transfers/maintenances/products/:id",
        name: "ViewTransferProduct",
        meta: { title: "Productos" },
        component: () => import(/* webpackChunkName: "transferproduct" */ "../views/TransferProducts/GetTransferProductView.vue"),
    },
    {
        path: "/transfers/maintenances/products/:id/edit",
        name: "EditTransferProduct",
        meta: { title: "Productos" },
        component: () => import(/* webpackChunkName: "transferproduct" */ "../views/TransferProducts/GetTransferProductView.vue"),
    },
    // TransferExtras
    {
        path: "/transfers/maintenances/extras",
        name: "GetAllTransferExtras",
        meta: { title: "Mantenimiento de extras" },
        component: () => import(/* webpackChunkName: "transferextra" */ "../views/TransferExtras/GetAllTransferExtrasView.vue"),
    },
    {
        path: "/transfers/maintenances/extras/new",
        name: "NewTransferExtra",
        meta: { title: "Nuevo extra" },
        component: () => import(/* webpackChunkName: "transferextra" */ "../views/TransferExtras/GetTransferExtraView.vue"),
    },
    {
        path: "/transfers/maintenances/extras/:id",
        name: "ViewTransferExtra",
        meta: { title: "Extra" },
        component: () => import(/* webpackChunkName: "transferextra" */ "../views/TransferExtras/GetTransferExtraView.vue"),
    },
    {
        path: "/transfers/maintenances/extras/:id/edit",
        name: "EditTransferExtra",
        meta: { title: "Extra" },
        component: () => import(/* webpackChunkName: "transferextra" */ "../views/TransferExtras/GetTransferExtraView.vue"),
    },
    // TransferRates
    {
        path: "/transfers/maintenances/rates",
        name: "GetAllTransferRates",
        meta: { title: "Tarifas" },
        component: () => import(/* webpackChunkName: "transferrate" */ "../views/TransferRates/GetAllTransferRatesView.vue"),
    },
    {
        path: "/transfers/maintenances/rates/new",
        name: "NewTransferRate",
        meta: { title: "Tarifas" },
        component: () => import(/* webpackChunkName: "transferrate" */ "../views/TransferRates/GetTransferRateView.vue"),
    },
    {
        path: "/transfers/maintenances/rates/:id",
        name: "ViewTransferRate",
        meta: { title: "Tarifas" },
        component: () => import(/* webpackChunkName: "transferrate" */ "../views/TransferRates/GetTransferRateView.vue"),
    },
    {
        path: "/transfers/maintenances/rates/:id/edit",
        name: "EditTransferRate",
        meta: { title: "Tarifas" },
        component: () => import(/* webpackChunkName: "transferrate" */ "../views/TransferRates/GetTransferRateView.vue"),
    },
    // TransferJourneys
    {
        path: "/transfers/booking/journeys",
        name: "GetAllTransferJourneys",
        meta: { title: "Trayectos" },
        component: () => import(/* webpackChunkName: "transferjbooking" */ "../views/TransferJourneys/GetAllTransferJourneysView.vue"),
    },

];


export default routes;
